import React from 'react';
import { AppBar, Toolbar, Button, Box, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { useAuth } from './context/AuthContext';

const LogoContainer = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
});

const Logo = styled('img')({
    height: 'auto',
    width: 'auto',
    maxWidth: '100px',
    minWidth: '50px',
});

const BetaLabel = styled(Typography)({
    marginLeft: 8,
    color: '#C63D57',
    fontWeight: 'bold',
    fontSize: '0.9rem',
    textTransform: 'uppercase',
});

const Spacer = styled(Box)({
    flexGrow: 1,
});

const NavigationBar = ({ isLoggedIn: isLoggedInProp, showDashboardLink: showDashboardLinkProp, handleLogout: handleLogoutProp }) => {
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const { currentUser, logout } = useAuth();

    // Use props if provided, otherwise derive from auth context
    const isLoggedIn = isLoggedInProp !== undefined ? isLoggedInProp : !!currentUser;
    const showDashboardLink = showDashboardLinkProp !== undefined ? showDashboardLinkProp : !!currentUser;

    const handleLogin = () => {
        navigate('/login');
    };

    const handleDashboard = () => {
        navigate('/dashboard');
    };

    const handleLogoutClick = async () => {
        if (handleLogoutProp) {
            handleLogoutProp();
        } else {
            try {
                await logout();
                navigate('/login');
            } catch (error) {
                console.error('Failed to log out', error);
            }
        }
    };

    const handleLogoClick = () => {
        navigate('/');
    };

    return (
        <AppBar position="fixed" style={{ backgroundColor: 'rgba(20, 20, 20, 0.8)' }}>
            <Toolbar>
                <LogoContainer onClick={handleLogoClick}>
                    <Logo
                        src="https://d3dbfxrvl5y81z.cloudfront.net/unitedai.png"
                        alt="United AI"
                    />
                    <BetaLabel>Beta</BetaLabel>
                </LogoContainer>
                <Spacer />
                {isLoggedIn ? (
                    <>
                        {showDashboardLink && (
                            <Button color="inherit" onClick={handleDashboard}>
                                Dashboard
                            </Button>
                        )}
                        <Button color="inherit" onClick={handleLogoutClick}>
                            Logout
                        </Button>
                    </>
                ) : (
                    <Button color="inherit" onClick={handleLogin}>
                        Login
                    </Button>
                )}
            </Toolbar>
        </AppBar>
    );
};

export default NavigationBar;